module.exports = __webpack_public_path__ + "static/media/support.7427f3df.png";